const HisPin = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0742 17.5391V22.5391"
        stroke={strokeColor}
        strokeWidth="2.00128"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.07422 17.5391H20.0742V15.7791C20.074 15.407 19.97 15.0423 19.7739 14.7261C19.5778 14.4099 19.2974 14.1546 18.9642 13.9891L17.1842 13.0891C16.851 12.9235 16.5706 12.6682 16.3745 12.352C16.1784 12.0358 16.0744 11.6711 16.0742 11.2991V6.53906H17.0742C17.6047 6.53906 18.1134 6.32835 18.4884 5.95328C18.8635 5.5782 19.0742 5.0695 19.0742 4.53906C19.0742 4.00863 18.8635 3.49992 18.4884 3.12485C18.1134 2.74978 17.6047 2.53906 17.0742 2.53906H9.07422C8.54379 2.53906 8.03508 2.74978 7.66 3.12485C7.28493 3.49992 7.07422 4.00863 7.07422 4.53906C7.07422 5.0695 7.28493 5.5782 7.66 5.95328C8.03508 6.32835 8.54379 6.53906 9.07422 6.53906H10.0742V11.2991C10.074 11.6711 9.97003 12.0358 9.77394 12.352C9.57785 12.6682 9.29743 12.9235 8.96422 13.0891L7.18422 13.9891C6.85101 14.1546 6.57059 14.4099 6.3745 14.7261C6.17841 15.0423 6.07442 15.407 6.07422 15.7791V17.5391Z"
        stroke={strokeColor}
        strokeWidth="2.00128"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisPin;
